const REQUIRED_KEYS = [
    'SPARK_DOMAIN',
    'BASE_DOMAIN',
    'AUTHENTICATION_SERVICE_URL',
    'ENV_NAME',
    'MODULE_NAME',
    'SPARK_TRAIL_NETWORKS_TAB_LINK',
    'SPARK_BULKDOWNLOAD_DOMAIN',
    'SPARK_GAP_PACKET_DOMAIN',
    'ANALYTICS_WAT_TOKEN_URL'
];

export function getConfig(key) {
    const runtime = window.APP_CONFIG && window.APP_CONFIG[key];
    if (runtime) {
        return runtime;
    }
    if (REQUIRED_KEYS.indexOf(key) !== -1) {
        throw new Error('Missing APP_CONFIG.' + key);
    }
    return '';
}

export const appConfig = {
    get ENV_NAME() {
        return getConfig('ENV_NAME');
    },
    get MODULE_NAME() {
        return getConfig('MODULE_NAME');
    },
    get SPARK_DOMAIN() {
        return getConfig('SPARK_DOMAIN');
    },
    get BASE_DOMAIN() {
        return getConfig('BASE_DOMAIN');
    },
    get SPARK_TRAIL_NETWORKS_TAB_LINK() {
        return getConfig('SPARK_TRAIL_NETWORKS_TAB_LINK');
    },
    get SPARK_BULKDOWNLOAD_DOMAIN() {
        return getConfig('SPARK_BULKDOWNLOAD_DOMAIN');
    },
    get SPARK_GAP_PACKET_DOMAIN() {
        return getConfig('SPARK_GAP_PACKET_DOMAIN');
    },
    get ANALYTICS_WAT_TOKEN_URL() {
        return getConfig('ANALYTICS_WAT_TOKEN_URL');
    }
};
